import { resolveRichTextFromGql } from './resolveRichTextFromGql'

export function withHttpsUrl(url) {
  if (!url) {
    return null
  }

  return url.startsWith('http') ? url : `https:${url}`
}

export function mapGqlAsset(image) {
  if (!image?.url) {
    return null
  }

  const url = withHttpsUrl(image.url)

  return {
    url,
    title: image.title ?? null,
    width: image.width ?? null,
    height: image.height ?? null,
    fileName: image.title ?? '',
    contentType: image.contentType ?? 'image/jpeg',
    details: {
      image: {
        width: image.width ?? null,
        height: image.height ?? null,
      },
    },
  }
}

export function mapAssetFields(target, fieldName, image) {
  const asset = mapGqlAsset(image)
  if (!asset) {
    return target
  }

  target[fieldName] = asset.url
  target[`${fieldName}Asset`] = asset

  return target
}

export function mapGqlAuthor(author) {
  if (!author) {
    return null
  }

  const mapped = {
    key: author.sys?.id ?? null,
    fullName: author.fullName ?? null,
    slug: author.slug ?? null,
    jobTitle: author.jobTitle ?? null,
    description: author.description ?? null,
    webPage: author.webPage ?? null,
    facebook: author.facebook ?? null,
    twitter: author.twitter ?? null,
    linkedIn: author.linkedIn ?? null,
  }

  mapAssetFields(mapped, 'avatar', author.avatar)

  return mapped
}

export function mapGqlRichText(content) {
  if (!content) {
    return null
  }

  return resolveRichTextFromGql(content)
}

/** Last-modified timestamp: updatedAt first, then sys.publishedAt. customPublishedDate stays separate. */
export function resolveUpdatedAt({ updatedAt, sys } = {}) {
  return updatedAt ?? sys?.publishedAt ?? null
}

/** Base entry fields matching parseEntry output. */
export function mapGqlEntryBase(item, contentType) {
  if (!item) {
    return null
  }

  return {
    contentType,
    key: item.sys?.id ?? null,
    updatedAt: resolveUpdatedAt(item),
    createdAt: item.sys?.createdAt ?? null,
  }
}
